import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  title?: string;
}

const BaseIcon: React.FC<IconProps & { path: React.ReactNode; viewBox?: string }> = ({
  size = 16,
  className,
  title,
  path,
  viewBox = '0 0 24 24',
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role={title ? 'img' : 'presentation'}
    aria-hidden={title ? undefined : true}
    aria-label={title}
  >
    {path}
  </svg>
);

export const IconBook: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<path d="M4 5.5C4 4.67 4.67 4 5.5 4H19a1 1 0 0 1 1 1v13.5a1.5 1.5 0 0 1-1.5 1.5H6.5A2.5 2.5 0 0 1 4 17.5V5.5Zm2.5.5a.5.5 0 0 0-.5.5v11c0 .83.67 1.5 1.5 1.5H18V6H6.5Z" fill="currentColor"/>}
  />
);

export const IconCheckCircle: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M8 12.5l2.5 2.5L16 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></>}
  />
);

export const IconDraft: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><path d="M7 4h8l4 4v12H7V4Z" stroke="currentColor" strokeWidth="2"/><path d="M15 4v4h4" stroke="currentColor" strokeWidth="2"/><path d="M10 14h6M10 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></>}
  />
);

export const IconArchive: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><rect x="4" y="5" width="16" height="4" stroke="currentColor" strokeWidth="2"/><path d="M6 9h12v10H6V9Z" stroke="currentColor" strokeWidth="2"/><path d="M10 13h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></>}
  />
);

export const IconGeneral: React.FC<IconProps> = (props) => <IconDraft {...props} />;
export const IconRelationships: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><circle cx="6" cy="7" r="2" stroke="currentColor" strokeWidth="2"/><circle cx="18" cy="7" r="2" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="17" r="2" stroke="currentColor" strokeWidth="2"/><path d="M7.8 8.3 10.2 15M16.2 8.3 13.8 15" stroke="currentColor" strokeWidth="2"/></>}
  />
);
export const IconDescription: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><rect x="5" y="4" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M8 9h8M8 13h8M8 17h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></>}
  />
);
export const IconSpark: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><path d="M12 4 13.7 8.3 18 10l-4.3 1.7L12 16l-1.7-4.3L6 10l4.3-1.7L12 4Z" stroke="currentColor" strokeWidth="2"/><path d="M18 4v2M19 5h-2M5 16v2M6 17H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></>}
  />
);
export const IconMetadata: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M12 8v4l2.5 2.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></>}
  />
);

export const IconEdit: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><path d="m14 5 5 5" stroke="currentColor" strokeWidth="2"/><path d="M5 19l3.5-.8L18 8.7 14.3 5 4.8 14.5 4 18z" stroke="currentColor" strokeWidth="2"/></>}
  />
);

export const IconDuplicate: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><rect x="9" y="9" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/><rect x="5" y="5" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/></>}
  />
);

export const IconDelete: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<><path d="M4 7h16" stroke="currentColor" strokeWidth="2"/><path d="M9 7V5h6v2M7 7l1 12h8l1-12" stroke="currentColor" strokeWidth="2"/></>}
  />
);

export const IconWarningDot: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<circle cx="12" cy="12" r="5" fill="currentColor"/>}
  />
);

export const IconChevronRight: React.FC<IconProps> = (props) => (
  <BaseIcon
    {...props}
    path={<path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>}
  />
);
